// extracted by mini-css-extract-plugin
module.exports = {"mobileMenu":"index-v2_mobileMenu_pvcj7","handler":"index-v2_handler_1WBft","handlerIcon":"index-v2_handlerIcon_22ijf"};